class LineItemMultishipValidator extends BaseMultishipValidator {
  constructor(element) {
    super();
    this.element = element;
    this.lineItemProperties = this.element.getAttribute('data-item-properties');
    this.lineItemIsValid = this.validateItem(this.lineItemProperties);
    this.hideOrShowLineItem(this.lineItemIsValid);
    this.checkShippingDate();
  }

  checkShippingDate() {
    this._loadShippingData();
    if (!this.isShippingDateValid(this.shippingData.requestedShipDate)) {
      this.showInvalidShippingDateNotification();
    } else {
      this.removeInvalidShippingDateNotification();
    }
  }

  showInvalidShippingDateNotification() {
    const existingNotification = this.element.querySelector('.invalid-shipping-date-notification');
    if (!existingNotification) {
      const notification = document.createElement('div');
      notification.className = 'invalid-shipping-date-notification';
      notification.setAttribute('role', 'alert');
      notification.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="calendar-icon" aria-hidden="true">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        Please update the shipping date. This date is no longer available.
      `;
      this.element.appendChild(notification);
    }
  }

  removeInvalidShippingDateNotification() {
    const existingNotification = this.element.querySelector('.invalid-shipping-date-notification');
    if (existingNotification) {
      existingNotification.remove();
    }
  }

  hideOrShowLineItem(isValid) {
    if (!isValid) {
      this.element.classList.remove('hidden');
    }
    // If validation fails we don't do anything
  }
}

function updateAllValidators() {
  const validators = document.querySelectorAll('[data-line-multiship-validatator]');
  validators.forEach(validator => new LineItemMultishipValidator(validator));
}

// Initialize validators when the DOM is ready
document.addEventListener('DOMContentLoaded', updateAllValidators);

document.addEventListener('cartUpdateCompleted', updateAllValidators);
